import {FormField, FormFieldType, SelectionOption} from 'lionheartland';

export class PostIngestFormFields {

    public entityName: FormField
    public data: FormField
    public organization: FormField

    constructor() {

        this.entityName = new FormField(
          'entityName',
          'Entity name',
          null,
          FormFieldType.text,
          true,
        )
        this.data = new FormField(
          'data',
          'Data',
          null,
          FormFieldType.text,
          true,
        )
        this.organization = new FormField(
          'organization',
          'Organization',
          'organization',
          FormFieldType.pushedSelectionList,
          true,
        )

    }
}

const fields = new PostIngestFormFields()

export const postIngestFormFieldOptions: {[key: string]: FormField} = {
  entityName: fields.entityName,
  data: fields.data,
  organization: fields.organization,
};